module.exports = __webpack_public_path__ + "static/media/Gilroy_bold.9747c221.woff";